(function ($) {


    $.normalizeString = function (str) {
        return str ? str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/\s/g, '') : '';
    };

    $.calculateDistance = function (lat1, lon1, lat2, lon2) {
        if (isNaN(lat1) || isNaN(lon1) || isNaN(lat2) || isNaN(lon2)) {
            return NaN;
        }
        const R = 6371; // Radius of the Earth in km
        const dLat = (lat2 - lat1) * Math.PI / 180;
        const dLon = (lon2 - lon1) * Math.PI / 180;
        const a =
            0.5 - Math.cos(dLat) / 2 +
            Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
            (1 - Math.cos(dLon)) / 2;

        return R * 2 * Math.asin(Math.sqrt(a));
    };
    function is_voting_active(cb) {

        $.ajax({
            url: localize.ajaxurl,
            type: "GET",
            data: {
                action: "ajax_is_voting_active",
            },
            error: function (err) {
                console.log(err)
                cb(false);
                return;
            },
            success: function (response) {
                cb(response);
                return;
            }
        });
    }

    $(() => {


        jQuery.fn.shuffle = function () {
            var j;
            for (var i = 0; i < this.length; i++) {
                j = Math.floor(Math.random() * this.length);
                $(this[i]).before($(this[j]));
            }
            return this;
        };

        var nomineeYears = $.unique($('[class*="js-rand-nominee-"]').map(function () {
            return this.dataset.year;
        }).get());

        const targetElement = document.querySelector('body')


        $('.js-show-cookie-settings').on('click', function (e) {
            e.preventDefault();

            if (typeof cookiedone === 'undefined1') {
                return false;
            }

            cookiedone.showCookieSettings();
            return false;
        })

        function preloading() {
            $('#preloader').fadeOut('400', function (e) {
                // bodyScrollLock.enableBodyScroll(targetElement);

                if (!$('.template--archive-nominee').length) {


                    if ($('[class*="js-rand-nominee-"]').length) {
                        $.each(nomineeYears, function (e, v) {
                            if ($(`.js-rand-nominee-${v}`).length > 1) {
                                $(`.js-rand-nominee-${v}`).shuffle();
                            }

                        })

                        $('[class*="js-rand-nominee-"]').matchHeight();
                    }
                }

            })
        }

        if ($('.template--front-page').length) {
            // bodyScrollLock.disableBodyScroll(targetElement);
            // window.animationEnd = preloading;
        } else {
            if (!$('.template--archive-nominee').length) {
                if ($('[class*="js-rand-nominee-"]').length) {
                    $.each(nomineeYears, function (e, v) {
                        if ($(`.js-rand-nominee-${v}`).length > 1) {
                            $(`.js-rand-nominee-${v}`).shuffle();
                        }
                    })
                }

                $('[class*="js-rand-nominee-"]').matchHeight();
            }
        }



        if ($(".js-mh-product-title").length) {
            $(".js-mh-product-title").matchHeight({
                byRow: true
            });
        }



        if ($(".js-mh-price").length) {
            $(".js-mh-price").matchHeight({
                byRow: true
            });
        }


        if ($(".js-mh-price-old").length) {
            $(".js-mh-price-old").matchHeight({
                byRow: true
            });
        }


        $('.js-filter-toggle').on('click', function (e) {
            e.preventDefault();
            $(this).toggleClass('open')
            $('.js-filter-toggle-wrapper').slideToggle();
        })


        $('.js-sidebar').stickySidebar({
            topSpacing: $('header').outerHeight(),
            bottomSpacing: 0,
            containerSelector: '.sidebar__container',
            innerWrapperSelector: '.plus-sidebar-wrapper',
            resizeSensor: true,
            minWidth: 1199,
        });

        objectFitImages();

        if ($('.template--front-page').length !== 0) {
            is_voting_active((res) => {
                if (res != 'false') {

                    $.ajax({
                        url: localize.ajaxurl,
                        type: "GET",
                        data: {
                            action: "get_votestart_block",
                        },
                        error: function (err) {
                            console.log(err)
                            return;
                        },

                        success: function (response) {
                            $('.section__votestart').append(response).promise().done(function (e) {
                                $('.section__nominees').addClass('has--vote');
                                $('.section__votestart').addClass('active');
                                $('.js-footer-wrapper').addClass('active');
                            });
                            return;
                        }
                    });
                }
            });
        }


        // Back to prev page functionality
        $(document).on('click', '.js-back-button', function () {
            var $goto = $(this).data('goto');

            if ($goto && document.referrer.includes($goto)) {
                window.location.href = $goto;
            } else {
                window.history.back();
            }
        });

        $(".js-order-select").on("change", function (e) {
            e.preventDefault();
            const searchTerm = $('#js-search').val()
            const term = $('.js-filter-button.active').attr('data-term');
            const locationSelect = $('.js-location-select option:selected');

            document.location.search = "o=" + $(this).val() + "&c=" + term + '&s=' + searchTerm + '&loc=' + locationSelect.val();
        });

        var $is_front_page = $('.template--front-page').length;


        $.fn.isInViewport = function () {
            var elementTop = $(this).offset().top;
            var elementBottom = elementTop + $(this).outerHeight();

            var viewportTop = $(window).scrollTop();
            var viewportBottom = viewportTop + $(window).height();

            return elementBottom > viewportTop && elementTop < viewportBottom;
        };

        function changeHeader() {
            if ($(window).scrollTop() > $('header').outerHeight()) {
                $("header").addClass("active");
                $('header').addClass('show--logo');
            } else {
                $('header').removeClass('show--logo');
                $("header").removeClass("active");
            }

            if ($is_front_page) {
                if ($('.js-hero-scroll').isInViewport()) {
                    $('.header--left-side').removeClass('show-logo');
                } else {
                    $('.header--left-side').addClass('show-logo');
                }
            }


        }

        changeHeader();

        $(window).on("scroll", function () {
            changeHeader();
        });



        /* Animate lighthouse */

        let lightHouseObserver = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('active');
                } else {
                    entry.target.classList.remove('active');
                }
            });
        });

        document.querySelectorAll('.footer__background_wrapper').forEach(lamp => {
            lightHouseObserver.observe(lamp);
        });

        var swiper = new Swiper(".js-gallery", {
            effect: "fade",
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
        });

        if ($('.js-more-song').length) {
            var songSwiper = new Swiper(".js-more-song", {

                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                }
            });
        }

        if ($('.js-product-slider').length) {

            var productSliderThumbs = new Swiper(".js-product-slider-thumbs", {
                loop: false,
                spaceBetween: 16,
                slidesPerView: 4,
                freeMode: false,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,

            });

            var productSlider = new Swiper(".js-product-slider", {
                loop: false,
                spaceBetween: 11,
                effect: "fade",
                thumbs: {
                    swiper: productSliderThumbs,
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
            });
        }


        if ($('.js-popular-products').length) {
            var popularProducts = new Swiper(".js-popular-products", {
                slidesPerView: 1,
                spaceBetween: 0,
                navigation: {
                    nextEl: ".js-popular-products-next",
                    prevEl: ".js-popular-products-prev",
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                breakpoints: {
                    575: {
                        slidesPerView: 1,
                    },
                    576: {
                        slidesPerView: 2,
                    },
                    768: {
                        slidesPerView: 2,
                    },
                    992: {
                        slidesPerView: 3,
                    },
                    1200: {
                        slidesPerView: 4,
                    },
                },


            });

        }

    });
})(jQuery);


